/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SellerShippingPrice_sellerShippingPriceResponseData$ref: FragmentReference;
declare export opaque type SellerShippingPrice_sellerShippingPriceResponseData$fragmentType: SellerShippingPrice_sellerShippingPriceResponseData$ref;
export type SellerShippingPrice_sellerShippingPriceResponseData = {|
  +calculateSellerShippingPrice: ?{|
    +locations: ?$ReadOnlyArray<?{|
      +locationCode: ?string,
      +locationName: ?string,
      +baseShippingFees: ?$ReadOnlyArray<?{|
        +locationCode: ?string,
        +locationName: ?string,
        +priceFrom: ?number,
        +priceTo: ?number,
        +shippingFee: ?number,
      |}>,
      +additionalShippingFeesWeight: ?$ReadOnlyArray<?{|
        +locationCode: ?string,
        +locationName: ?string,
        +referenceWeight: ?number,
        +shippingFee: ?number,
        +shippingFeePerAdditionalKilo: ?number,
        +shippingPlanDisplayId: ?number,
      |}>,
      +additionalShippingFeesQuantity: ?$ReadOnlyArray<?{|
        +locationCode: ?string,
        +locationName: ?string,
        +shippingFee: ?number,
        +shippingFeePerAdditionalQuantity: ?number,
        +shippingPlanDisplayId: ?number,
      |}>,
    |}>
  |},
  +$refType: SellerShippingPrice_sellerShippingPriceResponseData$ref,
|};
export type SellerShippingPrice_sellerShippingPriceResponseData$data = SellerShippingPrice_sellerShippingPriceResponseData;
export type SellerShippingPrice_sellerShippingPriceResponseData$key = {
  +$data?: SellerShippingPrice_sellerShippingPriceResponseData$data,
  +$fragmentRefs: SellerShippingPrice_sellerShippingPriceResponseData$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "locationCode",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "locationName",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingFee",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingPlanDisplayId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SellerShippingPrice_sellerShippingPriceResponseData",
  "type": "SellerShippingPriceSchemaType",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "sellerContactId",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "overseas",
      "type": "Boolean",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "calculateSellerShippingPrice",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "overseas",
          "variableName": "overseas"
        },
        {
          "kind": "Variable",
          "name": "sellerContactId",
          "variableName": "sellerContactId"
        }
      ],
      "concreteType": "SellerShippingPriceResponseSchemaType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "locations",
          "storageKey": null,
          "args": null,
          "concreteType": "sellerShippingPriceLocationResponseSchemaType",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "baseShippingFees",
              "storageKey": null,
              "args": null,
              "concreteType": "sellerBaseShippingFeesSchemaType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "priceFrom",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "priceTo",
                  "args": null,
                  "storageKey": null
                },
                (v2/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "additionalShippingFeesWeight",
              "storageKey": null,
              "args": null,
              "concreteType": "sellerAdditionalShippingFeesWeightSchemaType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "referenceWeight",
                  "args": null,
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "shippingFeePerAdditionalKilo",
                  "args": null,
                  "storageKey": null
                },
                (v3/*: any*/)
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "additionalShippingFeesQuantity",
              "storageKey": null,
              "args": null,
              "concreteType": "sellerAdditionalShippingFeesQuantitySchemaType",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "shippingFeePerAdditionalQuantity",
                  "args": null,
                  "storageKey": null
                },
                (v3/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '443426239f8bda017cbcd784d03d8432';
module.exports = node;
